export default function (other) {
  other = other || {};
  return {
    //Details fields

    ip: other.ip,
    alias: other.alias,
    orgId: other.orgId,
  };
}
